import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { footerColumns, resort } from "@/data/resort";

export function Footer() {
  return (
    <footer className="bg-forest-deep text-primary-foreground">
      <div className="shell py-14 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="font-display text-5xl leading-[0.9] tracking-[-0.03em] md:text-6xl">
              Auburn
              <span className="block text-primary-foreground/55">RV Resort</span>
            </p>
            <p className="eyebrow mt-8 text-accent">{resort.tagline}</p>
            <div className="mt-8 flex gap-3">
              {[Instagram, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={i === 0 ? "Instagram" : "Facebook"}
                  className="flex size-11 items-center justify-center rounded-full border border-primary-foreground/25 transition-colors hover:bg-primary-foreground hover:text-forest-deep"
                >
                  <Icon className="size-4" strokeWidth={1.6} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid gap-10 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-4">
            {footerColumns.map((col) => (
              <nav key={col.title} aria-label={col.title}>
                <h2 className="eyebrow text-primary-foreground/50">{col.title}</h2>
                <ul className="mt-5 space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="link-underline text-sm text-primary-foreground/85 hover:text-primary-foreground"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
            <div>
              <h2 className="eyebrow text-primary-foreground/50">Contact</h2>
              <ul className="mt-5 space-y-4 text-sm text-primary-foreground/85">
                <li className="flex gap-3">
                  <MapPin className="mt-0.5 size-4 shrink-0 text-accent" strokeWidth={1.6} />
                  <span>
                    {resort.address.street}
                    <br />
                    {resort.address.city}, {resort.address.state} {resort.address.zip}
                  </span>
                </li>
                <li className="flex gap-3">
                  <Phone className="mt-0.5 size-4 shrink-0 text-accent" strokeWidth={1.6} />
                  <a href={resort.phoneHref} className="link-underline">
                    {resort.phone}
                  </a>
                </li>
                <li className="flex gap-3">
                  <Mail className="mt-0.5 size-4 shrink-0 text-accent" strokeWidth={1.6} />
                  <a href={`mailto:${resort.email}`} className="link-underline">
                    {resort.email}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-5 border-t border-primary-foreground/15 pt-8 text-xs text-primary-foreground/55 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Auburn RV Resort. All rights reserved.</p>
          <ul className="flex flex-wrap gap-6">
            <li>
              <a href="/contact-us/" className="link-underline">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/contact-us/" className="link-underline">
                Terms
              </a>
            </li>
            <li>
              <a href="/contact-us/" className="link-underline">
                Accessibility
              </a>
            </li>
            <li>
              <a
                href="https://southeastpublications.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline"
              >
                Made by Love: Southeast Publications
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
